module.exports = __webpack_public_path__ + "static/img/MM.45a37eb6.svg";